module.exports = __webpack_public_path__ + "img/newJD-emptyData.61641e65.svg";